// extracted by mini-css-extract-plugin
export var center = "_53-2";
export var clickableRow = "_53-5";
export var expandedRow = "_53-7";
export var hoverable = "_53-4";
export var left = "_53-1";
export var right = "_53-3";
export var row = "_53-0";
export var selectedRow = "_53-6";